// Run this example by adding <%= javascript_pack_tag 'hello_react' %> to the head of your layout file,
// like app/views/layouts/application.html.erb. All it does is render <div>Hello React</div> at the bottom
// of the page.

import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import bugsnag from "@bugsnag/js";
import bugsnagReact from "@bugsnag/plugin-react";
import 'bootstrap/dist/css/bootstrap.min.css';
import { Provider } from 'react-redux'

import store from './customer_portal_app/helpers/store'
import AppRouter from './customer_portal_app/routers';

const bugsnagClient = bugsnag({
  releaseStage: process.env.BUGSNAG_RELEASE_STAGE || process.env.NODE_ENV,
  apiKey: "05c7e935706835daef7ce6b47d831a63",
  notifyReleaseStages: ["production", "staging"],
  user: {
    organization_id: window.gon.shoploader_org_id
  }
});

bugsnagClient.use(bugsnagReact, React);
const ErrorBoundary = bugsnagClient.getPlugin("react");

const pathIdComponent = !window.gon.using_subdomain
  ? `/${window.gon.shoploader_org_id}`
  : '';

const App =
  <ErrorBoundary>
    <Provider store={store}>
      <BrowserRouter>
        <AppRouter rootPath={`customer_portal${pathIdComponent}`}/>
      </BrowserRouter>
    </Provider>
  </ErrorBoundary>;

window.onload = () => ReactDOM.render(
  App,
  document.getElementById('customer_portal_root_element')
);
